import React, { useState, useEffect, useContext } from 'react'
import { Box, Text } from "grommet"

import TTJsonTree from '../common/TTJsonTree'
import Spinner from '../common/Spinner'

import axios from 'axios'

import { gql, useSubscription } from '@apollo/client';

import { FormStatusNotification } from '../common/FormStatusNotification'
import DiffDisplay from '../common/GitDiff'
import { useDefaultConf } from './TriageHeaders'
import TriageUrlContext from '../../context/TriageUrlContext'


const TASK_QUERY = gql`
subscription($taskId: String!) {
    jobtask(where: {taskid: {_eq: $taskId}}) {
        taskid
        result
        status
      }
}
`

const TriageCompare = ({ content }) => {

    const [result, setResult] = useState(false)
    const [resultURL, setResultURL] = useState(false)
    const [state, setState] = useState(false)

    const t3_url = useContext(TriageUrlContext)

    const { data: taskResult, loading: taskDataLoading } = useSubscription(
        TASK_QUERY, { variables: { taskId: content.taskid } }
    )

    const axiosConf = useDefaultConf()

    let t3TaskStatus = t3_url + '/api/1/taskstatus/' + content.taskid

    useEffect(() => {

        async function getStatusResponse() {

            const response = await axios(t3TaskStatus, axiosConf)
    
            if (response.status === 200) {
                if (response.data.state === "SUCCESS") {
                    setResult(response.data)
                    setResultURL(response.config.url)
                    setState(response.data.state)
                    return null
                }
                if (response.data.state === "PENDING") {
                    setResult(response.data)
                    setResultURL(response.config.url)
                    setState(response.data.state)
                    return null
                }
                if (response.data.state === "FAILURE") {
                    setResult(response.data)
                    setResultURL(response.config.url)
                    setState(response.data.state)
                    return null
                }
            }
    
        }

        if (!taskDataLoading && taskResult && taskResult.jobtask &&
            taskResult.jobtask.length > 0 && taskResult.jobtask[0].status !== 0
            && !(content.taskid.includes("MANUAL")) && state === false
        ) {
            getStatusResponse()
        }
    }, [axiosConf, taskDataLoading, taskResult, state, t3TaskStatus, content.taskid])

    return (
        <>
            <Box margin={{ left: '20px', top: '20px', right: '20px', bottom: '20px' }} gap="small">

                <Box direction="row" gap="small">
                    <Box>
                        <Text weight='bold'>Comparing Watcher Data vs LSD</Text>
                    </Box>
                </Box>

                {((content && content.taskid && (content.taskid.includes("MANUAL")) && result) || taskDataLoading) &&
                    <Spinner />
                }

                {
                    !resultURL &&
                    <Spinner />
                }

                <Box height="80%">
                    {taskResult && taskResult.jobtask &&
                        taskResult.jobtask.length > 0 && taskResult.jobtask[0].status && taskResult.jobtask[0].status !== 0 &&
                        taskResult.jobtask[0].result && taskResult.jobtask[0].result.length > 0 &&
                        <FormStatusNotification
                            header="Encountered An Error Message From Triage REST API"
                            subheader={taskResult.jobtask[0].result}
                            error={true}
                        />
                    }
                    {!taskDataLoading && content.taskid && content.taskid.indexOf("MANUAL") === -1 && result &&
                        result.results && !result.results.triage_files &&
                        <DiffDisplay 
                            oldValue={content.zookeeperData} 
                            newValue={result.results}
                            mTimeHasura={content.mTimeHasura}
                            // leftTitle="Watcher Data"
                            // rightTitle="LSD"
                        />
                    }
                    {!taskDataLoading && content.taskid && content.taskid.indexOf("MANUAL") === -1 && result &&
                        result.state && result.state === "FAILURE" &&
                        // SHOW FAILURES
                        <TTJsonTree data={result} expandAll={true} />
                    }
                </Box>
            </Box>
        </>
    )
}

export default TriageCompare